export enum BaseCustomerUnpublishedInquiryActionsEnum {
  close = 'states.close',
  release = 'states.release',
  edit = 'states.edit',
}
